// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#button-container {
  display: flex;
  height: -moz-fit-content;
  height: fit-content;
}
#button-container .btn-block {
  font-size: 16px;
  font-weight: 600;
  line-height: 19px;
  border: unset;
  outline: none;
  border-radius: 10px;
  padding: 0px 20px;
  min-height: 46px;
}
#button-container .btn-block:disabled {
  opacity: 0.7;
}
#button-container .PD {
  background-color: var(--56ff);
  border: 1px solid var(--56ff);
  color: var(--ffff);
}
#button-container .PO {
  background-color: var(--ffff);
  color: var(--56ff);
  border: 1px solid var(--56ff);
}
#button-container .SD {
  background-color: #61c454;
  border: 1px solid #61c454;
  color: var(--ffff);
}
#button-container .RD {
  background-color: var(--4639);
  border: 1px solid var(--4639);
  color: var(--ffff);
}
#button-container .WD {
  background-color: var(--ffc1);
  border: 1px solid var(--ffc1);
  color: var(--0000);
}
#button-container .DD {
  background-color: var(--0000);
  border: 1px solid var(--0000);
  color: var(--ffff);
}
#button-container .SO {
  background-color: var(--ffff);
  color: var(--8754);
  border: 1px solid var(--8754);
}
#button-container .RO {
  background-color: var(--ffff);
  color: var(--dc35);
  border: 1px solid var(--dc35);
}
#button-container .WO {
  background-color: var(--ffff);
  color: var(--ffc1);
  border: 1px solid var(--ffc1);
}
#button-container .DO {
  background-color: var(--ffff);
  color: var(--0000);
  border: 1px solid var(--0000);
}
#button-container .GD {
  background-color: var(--edf0);
  color: var(--2749);
  border: 1px solid var(--edf0);
}
#button-container .MD {
  background-color: transparent;
  color: var(--56ff);
  border: 1px solid var(--56ff);
}`, "",{"version":3,"sources":["webpack://./src/components/inputs/Button/Button.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,wBAAA;EAAA,mBAAA;AACF;AAAE;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,iBAAA;EACA,gBAAA;AAEJ;AADI;EACE,YAAA;AAGN;AAAE;EACE,6BAAA;EACA,6BAAA;EACA,kBAAA;AAEJ;AAAE;EACE,6BAAA;EACA,kBAAA;EACA,6BAAA;AAEJ;AAAE;EACE,yBAAA;EACA,yBAAA;EACA,kBAAA;AAEJ;AAAE;EACE,6BAAA;EACA,6BAAA;EACA,kBAAA;AAEJ;AAAE;EACE,6BAAA;EACA,6BAAA;EACA,kBAAA;AAEJ;AAAE;EACE,6BAAA;EACA,6BAAA;EACA,kBAAA;AAEJ;AACE;EACE,6BAAA;EACA,kBAAA;EACA,6BAAA;AACJ;AACE;EACE,6BAAA;EACA,kBAAA;EACA,6BAAA;AACJ;AACE;EACE,6BAAA;EACA,kBAAA;EACA,6BAAA;AACJ;AACE;EACE,6BAAA;EACA,kBAAA;EACA,6BAAA;AACJ;AACE;EACE,6BAAA;EACA,kBAAA;EACA,6BAAA;AACJ;AACE;EACE,6BAAA;EACA,kBAAA;EACA,6BAAA;AACJ","sourcesContent":["#button-container {\r\n  display: flex;\r\n  height: fit-content;\r\n  .btn-block {\r\n    font-size: 16px;\r\n    font-weight: 600;\r\n    line-height: 19px;\r\n    border: unset;\r\n    outline: none;\r\n    border-radius: 10px;\r\n    padding: 0px 20px;\r\n    min-height: 46px;\r\n    &:disabled {\r\n      opacity: 0.7;\r\n    }\r\n  }\r\n  .PD {\r\n    background-color: var(--56ff);\r\n    border: 1px solid var(--56ff);\r\n    color: var(--ffff);\r\n  }\r\n  .PO {\r\n    background-color: var(--ffff);\r\n    color: var(--56ff);\r\n    border: 1px solid var(--56ff);\r\n  }\r\n  .SD {\r\n    background-color: #61c454;\r\n    border: 1px solid #61c454;\r\n    color: var(--ffff);\r\n  }\r\n  .RD {\r\n    background-color: var(--4639);\r\n    border: 1px solid var(--4639);\r\n    color: var(--ffff);\r\n  }\r\n  .WD {\r\n    background-color: var(--ffc1);\r\n    border: 1px solid var(--ffc1);\r\n    color: var(--0000);\r\n  }\r\n  .DD {\r\n    background-color: var(--0000);\r\n    border: 1px solid var(--0000);\r\n    color: var(--ffff);\r\n  }\r\n\r\n  .SO {\r\n    background-color: var(--ffff);\r\n    color: var(--8754);\r\n    border: 1px solid var(--8754);\r\n  }\r\n  .RO {\r\n    background-color: var(--ffff);\r\n    color: var(--dc35);\r\n    border: 1px solid var(--dc35);\r\n  }\r\n  .WO {\r\n    background-color: var(--ffff);\r\n    color: var(--ffc1);\r\n    border: 1px solid var(--ffc1);\r\n  }\r\n  .DO {\r\n    background-color: var(--ffff);\r\n    color: var(--0000);\r\n    border: 1px solid var(--0000);\r\n  }\r\n  .GD {\r\n    background-color: var(--edf0);\r\n    color: var(--2749);\r\n    border: 1px solid var(--edf0);\r\n  }\r\n  .MD {\r\n    background-color: transparent;\r\n    color: var(--56ff);\r\n    border: 1px solid var(--56ff);\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
